import { createEnvelopeSource } from './create-envelope-source';

/**
 * RPP login-retention source (`GET /analytics/login-retention-rpp`), the same
 * three ratios as `login-retention` over the RPP audience.
 *
 * Spans browser and WebView, deduped, and carries no surface split: unlike a
 * login, coming back does not depend on the surface, so every rate is honest
 * over the whole audience.
 *
 * Registered players only, so the rates are NOT comparable with the full-app
 * ones: read them side by side, never as a whole and a part.
 */
export const loginRetentionRppSource = createEnvelopeSource({
    label: 'RPP login retention',
    endpoint: 'analytics/login-retention-rpp',
    metrics: [
        {
            id: 'repeatVisitRateRpp',
            label: 'RPP repeat visit rate',
            type: 'ratio',
        },
        {
            id: 'returningUserRateRpp',
            label: 'RPP returning user rate',
            type: 'ratio',
        },
        {
            id: 'averageActiveDaysPerUserRpp',
            label: 'RPP average active days per user',
            type: 'ratio',
        },
    ],
    forms: ['rate', 'number', 'bars'],
    regionGrain: 'province',
});
